import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../api/client";
import { useAuth } from "../context/AuthContext";
import { ru } from "../locales/ru";

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { phone, password });
      setUser(data);
      navigate("/profile");
    } catch (err) {
      setError(formatApiError(err, ru.errors.generic));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center px-6 pb-24">
      <h1 className="text-4xl font-extrabold tracking-tight mb-2" data-testid="login-title">
        {ru.auth.loginTitle}
      </h1>
      <p className="text-gray-500 mb-10">{ru.app.name}</p>
      <form onSubmit={submit} className="space-y-4">
        <input
          data-testid="login-phone-input"
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder={ru.auth.phonePlaceholder}
          className="w-full h-14 px-4 bg-gray-100 rounded-xl text-base outline-none focus:ring-2 focus:ring-black"
          required
        />
        <input
          data-testid="login-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={ru.auth.password}
          className="w-full h-14 px-4 bg-gray-100 rounded-xl text-base outline-none focus:ring-2 focus:ring-black"
          required
        />
        {error && (
          <p data-testid="login-error" className="text-sm text-[#FF3B30] px-1">{error}</p>
        )}
        <button
          data-testid="login-submit-button"
          type="submit"
          disabled={loading}
          className="w-full h-14 bg-black text-white rounded-2xl font-medium text-base active:scale-[0.98] transition-transform duration-200 disabled:opacity-50"
        >
          {ru.auth.loginBtn}
        </button>
      </form>
      <p className="text-center text-sm text-gray-500 mt-8">
        {ru.auth.noAccount}{" "}
        <Link to="/register" data-testid="login-to-register-link" className="text-black font-semibold underline">
          {ru.auth.toRegister}
        </Link>
      </p>
    </div>
  );
}
